<template>
  <button class="BackButton btn btn-secondary" @click="goBack()">
    <i class="fa fa-angle-double-left mr-1"></i>
    {{ $t("global.go_back") }}
  </button>
</template>

<script>
export default {
  name: "BackButton",
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
